// get all cities
export const FLAG_GETTING_CITIES = 'FLAG_GETTING_CITIES';
export const GET_CITIES = 'GET_CITIES';
export const CLEAR_CITIES = 'CLEAR_CITIES';
